<template>
  <div>
    <RepaymentHead />
    <div class="repayment-context">
      <el-table :data="tableData" style="width: 100%; font-weight:888;">
        <el-table-column 
          class=".el-table-column"
          prop="name"
          style="width: 30%"
        ></el-table-column>
        <!-- <el-table-column prop="bankcard" label="bankcard" style="width: 30%"></el-table-column>
        <el-table-column prop="yhra" label="repaymentAmount" style="width: 30%"></el-table-column> -->
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import RepaymentHead from "../components/RepaymentHead.vue";
export default {
  data() {
    return {
      RepaymentAmount: "",
      tableData: [
        {
          name: "",
        },
        {
          name: "",
        },
        {
          name: "",
        },
        {
          name: "",
        },
        {
          name: "",
        },
        {
          name: "",
        },
        {
          name: "",
        },
        {
          name: "",
        },
        {
          name: "",
        },
      ],
    };
  },
  methods: {
    getInformation() {
      var token = sessionStorage.getItem("token");
      axios
        .get(`/Repaybank/queryRepaybank?uid=${1}`, {
          withCredentials: true,
        })
        .then((res) => {
          // //console.log(res.data.data);

          this.tableData[0].name = res.data.data["bankname"];
          this.tableData[1].name = res.data.data["bankcard"];
          // his.tableData[2].name =
          //  this.tableData[2].name="P  " +`${+res.data.data["balance"]}`
          // //console.log(this.tableData)
        })
        .catch(() => {});
    },
    getInformation2() {
      var token = sessionStorage.getItem("token");
      axios
        .get(`/Repaybank/queryRepaybank?uid=${2}`, {
          withCredentials: true,
        })
        .then((res) => {
          // //console.log(res.data.data);

          this.tableData[2].name = res.data.data["bankname"];
          this.tableData[3].name = res.data.data["bankcard"];
          // his.tableData[2].name =
          //  this.tableData[2].name="P  " +`${+res.data.data["balance"]}`
          // //console.log(this.tableData)
        })
        .catch(() => {});
    },

    getInformation3() {
      var token = sessionStorage.getItem("token");
      axios
        .get(`/Repaybank/queryRepaybank?uid=${3}`, {
          withCredentials: true,
        })
        .then((res) => {
          // //console.log(res.data.data);

          this.tableData[4].name = res.data.data["bankname"];
          this.tableData[5].name = res.data.data["bankcard"];
          // his.tableData[2].name =
          //  this.tableData[2].name="P  " +`${+res.data.data["balance"]}`
          // //console.log(this.tableData)
        })
        .catch(() => {});
    },

    getInformation4() {
      var token = sessionStorage.getItem("token");
      axios
        .get(`/Repaybank/queryRepaybank?uid=${4}`, {
          withCredentials: true,
        })
        .then((res) => {
          //console.log(res);
          this.tableData[6].name = res.data.data["bankname"];
          this.tableData[7].name = res.data.data["bankcard"];
          // his.tableData[2].name =
          //  this.tableData[2].name="P  " +`${+res.data.data["balance"]}`
          // //console.log(this.tableData)
        })
        .catch(() => {});
    },

    getRepayment() {
      axios
        .get(`/walletSys/wallet/yhra/${+sessionStorage.getItem("token")}`, {
          withCredentials: true,
        })
        .then((res) => {
          // this.yhraInf = res.data.data[];
          // //console.log(res.data.data);
          this.tableData[8].name =`₱ ${+res.data.data["yhra"]}`;
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getInformation();
    this.getInformation2();
    this.getInformation3();
    this.getInformation4();
    this.getRepayment();
  },
  components: {
    RepaymentHead,
  },
};
</script>

<style scoped>
.repayment-context {
  margin-top: 40px;
}

::v-deep .el-table-column {
  border: none;
}
.repayment-context .right {
  text-align: right;
  background: red;
}
</style>